module.exports = __webpack_public_path__ + "svg/illustration-money.82f2fdb.svg";